import script from "./SystemOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemOverview.vue?vue&type=script&setup=true&lang=js"

import "./SystemOverview.vue?vue&type=style&index=0&id=1dc2b584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc2b584"]])

export default __exports__